import { Button } from "react-bootstrap";
import internet from "../images/internet.webp";
import { useNavigate } from "react-router-dom";

function NetworkChecker() {
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const currentUrl = queryParameters.get("currentUrl");

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        zIndex: 9999,
        padding: "20px",
      }}
    >
      <img src={internet} alt="connection status" className="mb-3" style={{ maxWidth: "180px" }} />
      <h1 className="text-danger">
        <b>WHOOPS!</b>
      </h1>
      <p className="fs-5 text-dark"><b>SLOW OR NO INTERNET CONNECTION</b></p>
      <p className="text-dark f-18">Please check your connection and try again.</p>
      <Button
        variant="success"
        className="mt-5"
        size="lg"
        onClick={() => navigate(currentUrl)}
      >
        <i className="bi bi-arrow-clockwise"></i> Try Again
      </Button>
    </div>
  );
}

export default NetworkChecker;
